var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white-background-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"pt-1"},[_c('why-should-i'),_c('am-i-eligible'),_c('whats-expected'),_c('other-way-you-can-help')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }